import { render, staticRenderFns } from "./vlogPlayer.vue?vue&type=template&id=3a4ca71a&scoped=true&"
import script from "./vlogPlayer.vue?vue&type=script&lang=js&"
export * from "./vlogPlayer.vue?vue&type=script&lang=js&"
import style0 from "./vlogPlayer.vue?vue&type=style&index=0&id=3a4ca71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ca71a",
  null
  
)

export default component.exports